module.exports = __webpack_public_path__ + "img/fieldbanner.f6362980.png";